/**
 * Em'z Blendz Cart Drawer Initialization Fix
 * Version: 1.1.0
 * 
 * This script fixes the cart drawer functionality by properly initializing
 * theme.CartDrawer and theme.AjaxProduct which are defined but not always
 * instantiated on product forms.
 * 
 * Root cause: The Impulse theme expects forms with class "product-single__form"
 * but Em'z customizations use "product-form" class. This script bridges that gap.
 */

(function() {
  'use strict';

  // Wait for DOM and theme to be ready
  function initCartDrawer() {
    // Ensure theme object and required classes exist
    if (typeof theme === 'undefined' || !theme.CartDrawer || !theme.settings) {
      console.warn('[EMZ Cart] Theme not ready, retrying...');
      setTimeout(initCartDrawer, 100);
      return;
    }

    // Only initialize if cart type is drawer
    if (theme.settings.cartType !== 'drawer') {
      console.log('[EMZ Cart] Cart type is not drawer, skipping initialization');
      return;
    }

    // Check if CartDrawer already exists
    if (!theme.cartDrawer) {
      try {
        theme.cartDrawer = new theme.CartDrawer();
        console.log('[EMZ Cart] CartDrawer initialized successfully');
      } catch (e) {
        console.error('[EMZ Cart] Failed to initialize CartDrawer:', e);
      }
    }

    // Initialize AjaxProduct on all product forms
    initAjaxProductForms();
  }

  function initAjaxProductForms() {
    if (!theme.AjaxProduct) {
      console.warn('[EMZ Cart] AjaxProduct class not available');
      return;
    }

    // Find all product forms - try multiple selectors
    var selectors = [
      'form.product-form',                    // Em'z custom class
      'form.product-single__form',            // Impulse default class
      'form[action*="/cart/add"]',            // Any add-to-cart form
      '.product-form-container form'          // Forms in product containers
    ];
    
    var forms = document.querySelectorAll(selectors.join(', '));
    
    forms.forEach(function(form) {
      // Skip if already initialized
      if (form.dataset.ajaxProductInitialized) {
        return;
      }

      // Skip non-product forms (contact forms, etc.)
      if (form.classList.contains('contact-form') || 
          form.classList.contains('newsletter-form') ||
          !form.querySelector('[data-add-to-cart], [name="add"], button[type="submit"]')) {
        return;
      }

      // Skip if form doesn't have an action pointing to cart/add
      if (form.action && form.action.indexOf('/cart/add') === -1 && 
          form.action.indexOf('/cart') === -1) {
        return;
      }

      try {
        new theme.AjaxProduct(form);
        form.dataset.ajaxProductInitialized = 'true';
        console.log('[EMZ Cart] AjaxProduct initialized for form:', form.id || form.className);
      } catch (e) {
        console.error('[EMZ Cart] Failed to initialize AjaxProduct:', e);
      }
    });
  }

  // Re-initialize forms when new content is loaded (for Quick View, AJAX, etc.)
  function observeNewForms() {
    if (typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function(mutations) {
      var shouldInit = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              // Check if a form was added or if the added node contains forms
              if (node.matches && (
                  node.matches('form.product-form') || 
                  node.matches('form.product-single__form') ||
                  node.matches('form[action*="/cart/add"]'))) {
                shouldInit = true;
              } else if (node.querySelectorAll) {
                var nestedForms = node.querySelectorAll('form.product-form, form.product-single__form, form[action*="/cart/add"]');
                if (nestedForms.length > 0) {
                  shouldInit = true;
                }
              }
            }
          });
        }
      });

      if (shouldInit) {
        // Debounce to avoid multiple rapid initializations
        clearTimeout(window.emzCartFormTimeout);
        window.emzCartFormTimeout = setTimeout(initAjaxProductForms, 100);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      // Small delay to ensure theme JS has run first
      setTimeout(function() {
        initCartDrawer();
        observeNewForms();
      }, 100);
    });
  } else {
    // DOM already loaded - still add small delay for theme JS
    setTimeout(function() {
      initCartDrawer();
      observeNewForms();
    }, 100);
  }

  // Also handle Shopify section events (for theme editor)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(initAjaxProductForms, 100);
  });

  // Handle modal/quickshop opens
  document.addEventListener('modalOpen', function() {
    setTimeout(initAjaxProductForms, 200);
  });

})();
